import React, { Component } from "react";
import HidonPage from "./HidonPage"
import { apiURL } from "../Services/baseURL"
import "./SignPage.scss"
import { usingQuizzesAPI, quizID } from "../Services/fetchService";
import { DomField, DomSelect, DomCheckboxField, DomBoolCheckbox } from "../Services/FormDOM";
import { checkInput, returnValue } from "../Services/Validation";

Object.filter = function (obj, predicate) {
    var result = {}, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key) && predicate(obj[key])) {
            result[key] = obj[key];
        }
    }

    return result;
};

export default class SignPage extends Component {
    constructor() {
        super();
        this.addState = this.addState.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.setErrorMessage = this.setErrorMessage.bind(this);
        this.sendForm = this.sendForm.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.state = {
            isBusy: false,
            isDetailsFilled: false
        }
    }
    componentDidMount() {
        // this.nextPage();
    }
    addState(stateName, isRequired) {
        this.setState({
            [stateName]: {
                name: stateName,
                value: "",
                isRequired: !isRequired ? false : true
            }
        })
    }
    handleInputChange(event) {
        this.setState({
            [event.target.name]: {
                ...this.state[event.target.name],
                error: "",
                value: (event.target.dataset && event.target.dataset.bool === "true" ? (this.state[event.target.name].value ? 0 : 1) : event.target.value)
            }
        });
    }
    setErrorMessage(target, errorMsg) {
        if (!this.state[target.name]) return;

        this.setState({
            [target.name]: {
                ...target,
                error: errorMsg
            }
        });
    }
    nextPage() {
        this.setState({
            isDetailsFilled: true
        }, () => this.props.setPage("hidon"));
    }
    async sendForm() {
        if (this.state.isBusy) return;

        this.setState({
            isLoading: true,
            isBusy: true
        });

        let isError = false,
            j = 0,
            jsonBody = {},
            state = Object.filter(this.state, s => s.isRequired),
            fieldStateKeys = Object.keys(state);

        for (let s in state) {
            if (await !checkInput(state[s], this.setErrorMessage)) isError = true;
            j++;
        }

        for (let k in fieldStateKeys) {
            jsonBody = Object.assign(jsonBody, {
                [fieldStateKeys[k]]: returnValue(state[fieldStateKeys[k]])
            });
        }

        if (isError && j == fieldStateKeys.length) {
            this.setState({
                isLoading: false,
                isBusy: false
            })
            return;
        }

        let isExists = await usingQuizzesAPI.isAlreadyExists({
            Email: returnValue(state["Email"]),
            PhoneNumber: returnValue(state["PhoneNumber"])
        });

        if (isExists) {
            this.props.setPage("totalend");
            return;
        }

        this.nextPage();
    }
    render() {
        switch (this.state.isDetailsFilled) {
            case false:
                return (
                    <div>
                        <div className="trailer">
                            <a href="https://www.youtube.com/watch?v=KLFKmhsBTek" target="_blank">
                                <div className="link-video"></div>
                            </a>
                        </div>
                        <section className="section section-form">
                            <div className="padding">
                                <div className="container">
                                    <div className="form">
                                        <DomField
                                            type="text"
                                            max={64}
                                            label="שם מלא"
                                            placeholder="שם מלא"
                                            name="FullName"
                                            id="FullName"
                                            isRequired
                                            onChange={this.handleInputChange}
                                            onLoad={this.addState}
                                            {...this.state} />
                                        <div className="moreinfo">
                                            <DomField
                                                type="tel"
                                                max={64}
                                                label="גיל"
                                                placeholder="גיל"
                                                name="Age"
                                                id="Age"
                                                isRequired
                                                onChange={this.handleInputChange}
                                                onLoad={this.addState}
                                                {...this.state} />
                                            <DomSelect
                                                placeholder="מין"
                                                name="Gender"
                                                id="Gender"
                                                isRequired
                                                onChange={this.handleInputChange}
                                                onLoad={this.addState}
                                                {...this.state} />
                                        </div>
                                        <DomField
                                            type="email"
                                            max={64}
                                            label="מייל"
                                            placeholder="מייל"
                                            name="Email"
                                            id="Email"
                                            isRequired
                                            onChange={this.handleInputChange}
                                            onLoad={this.addState}
                                            {...this.state} />
                                        <DomField
                                            type="tel"
                                            max={64}
                                            label="טלפון"
                                            placeholder="טלפון"
                                            name="PhoneNumber"
                                            id="PhoneNumber"
                                            isRequired
                                            onChange={this.handleInputChange}
                                            onLoad={this.addState}
                                            {...this.state} />
                                        <DomBoolCheckbox
                                            label={`קראתי, הבנתי, ומסכים <a href=${`https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html`} target="_blank">לתנאי השימוש</a>, <a href=${`https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html`} target="_blank">למדיניות הפרטיות</a> ו<a href=${`https://z.ynet.co.il/mShort/generics/Quizzes/TOS/${quizID}/`} target="_blank">לתקנון הפעילות</a>, וכן נותן הסכמתי למשלוח דברי פרסום לפי פרטיי לעיל`}
                                            type="checkbox"
                                            name="TOS"
                                            id="TOS"
                                            isRequired
                                            onChange={this.handleInputChange}
                                            onLoad={this.addState}
                                            {...this.state}
                                        />
                                        <div className="button">
                                            {/* <div className="button-text g-recaptcha" data-sitekey="6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU" onClick={this.sendForm}></div> */}
                                            <div className="button-text" onClick={this.sendForm}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                )
                break;
            case true:
                return (
                    <div>
                        <HidonPage
                            QuizQuestions={this.props.QuizQuestions}
                            QuizQuestionslength={this.props.QuizQuestions.length}
                            setPage={this.props.setPage}
                            state={this.state} />
                    </div>
                )
                break;
        }
    }
}


// WEBPACK FOOTER //
// ./src/Components/Body/SignPage.jsx